import { isDefined } from '@aloft/toolkit-shared';
import { Badge, BadgeVariant, Block, Typography } from '@aloft/toolkit-sui';

import { selectDeviceWidth } from '../../../../redux/features/selectors/uiSelectors.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';

export const OrderCardDatum = ({
  textPrimary,
  textSecondary,
  label,
  badge,
}: {
  textPrimary: string;
  textSecondary?: string;
  label: string;
  badge?: { text: string; variant: BadgeVariant };
}) => {
  const deviceWidth = useAppSelector(selectDeviceWidth);

  return (
    <div className="order-card-datum">
      {deviceWidth === 'phone' && (
        <div className="order-card-datum-label">
          <Typography variant="body1" color="textTertiary">
            {label}
          </Typography>
        </div>
      )}
      <Block>
        <Typography variant="h3">{textPrimary}</Typography>
        {isDefined(textSecondary) && (
          <Typography
            variant="h3"
            color="textTertiary"
            __dangerDoNotUseSx={{
              fontWeight: 500,
              overflow: 'hidden',
              maxWidth: '175px',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}
          >
            {textSecondary}
          </Typography>
        )}
        {isDefined(badge) && <Badge variant={badge.variant} size="xs" text={badge.text} />}
      </Block>
    </div>
  );
};
